import React, { useRef } from 'react';
import { Button, Popconfirm, Slider, Spin, Tooltip } from 'antd';

export default function RefImagePanel({
  refImage,
  imageOpacity,
  tiffLoading,
  onImageUpload,
  onOpacityChange,
  onResetToView,
  onClearImage,
}) {
  const fileInputRef = useRef(null);

  return (
    <div className="poi-ref-panel">
      <div className="poi-panel-header">
        <span className="poi-panel-title">Reference Image</span>
        {refImage && (
          <Popconfirm title="Remove reference image?" onConfirm={onClearImage} okText="Yes" cancelText="No">
            <Button size="small" type="danger">Remove</Button>
          </Popconfirm>
        )}
      </div>

      {!refImage ? (
        <div className="poi-ref-upload-row">
          <Spin spinning={!!tiffLoading} tip="Decoding TIFF…">
            <Button
              icon="picture"
              type="dashed"
              block
              disabled={!!tiffLoading}
              onClick={() => fileInputRef.current && fileInputRef.current.click()}
            >
              Upload Reference Image
            </Button>
          </Spin>
          <p className="poi-upload-hint">PNG, JPG or TIFF / GeoTIFF — overlay on map to trace shapes on top. GeoTIFF bounds are detected automatically.</p>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*,.tif,.tiff,image/tiff"
            style={{ display: 'none' }}
            onChange={(e) => {
              const file = e.target.files && e.target.files[0];
              if (file) onImageUpload(file);
              e.target.value = '';
            }}
          />
        </div>
      ) : (
        <div style={{ padding: '8px 10px' }}>
          <div className="poi-field">
            <label>Opacity</label>
            <Slider
              min={0.05}
              max={1}
              step={0.05}
              value={imageOpacity}
              onChange={onOpacityChange}
            />
          </div>

          <div className="poi-ref-hint-box">
            <p className="poi-ref-hint-line">
              <strong>Drag the orange corner handles</strong> on the map to reposition and resize the image.
            </p>
            <p className="poi-ref-hint-line">
              Draw shapes on top to trace the layout.
            </p>
          </div>

          <div className="poi-btn-row" style={{ marginTop: 6 }}>
            <Tooltip title="Reset overlay to the current map view bounds">
              <Button size="small" icon="reload" onClick={onResetToView}>
                Reset to View
              </Button>
            </Tooltip>
          </div>

          {refImage.naturalWidth > 0 && (
            <div className="poi-gcp-hint" style={{ marginTop: 6 }}>
              {refImage.naturalWidth} × {refImage.naturalHeight} px
            </div>
          )}
        </div>
      )}
    </div>
  );
}
